export default {
    COLUMN_GRID: 'COLUMN_GRID',
    BANNER: 'BANNER',
    BANNER_V2: 'BANNER_V2',
    IMAGE: 'IMAGE',
    TEXT_ONLY: 'TEXT_ONLY',
    TEXT_GRID: 'TEXT_GRID',
    CAROUSEL_CHILD: 'CAROUSEL_CHILD',
    CAROUSEL: 'CAROUSEL',
    SLIDING_WIDGET: 'SLIDING_WIDGET',
    SEO_DATA: 'SEO_DATA',
    IN_FOCUS: 'IN_FOCUS',
    APP_CONFIG: 'APP_CONFIG',
    FITCODE_PROFILE: 'FITCODE_PROFILE',
    BUTTON_GRID: 'BUTTON_GRID',
    BUTTON: 'BUTTON',
    SLIDING_WIDGET_V2: 'SLIDING_WIDGET_V2',
    COLUMN_GRID_V2: 'COLUMN_GRID_V2',
    CAROUSEL_V2: 'CAROUSEL_V2',
    SECTION: 'SECTION',
    RECOMMENDATION_WIDGET: 'RECOMMENDATION_WIDGET',
    PRODUCT_WIDGET: 'PRODUCT_WIDGET',
    PRODUCT_WIDGET_V2_CHILD: 'PRODUCT_WIDGET_V2_CHILD',
    STORY: 'STORY',
    PRODUCT_WIDGET_V2: 'PRODUCT_WIDGET_V2',
    VIDEO: 'VIDEO',
    LIST_VIEW_CHILD: 'LIST_VIEW_CHILD',
    LIST_VIEW_WIDGET: 'LIST_VIEW_WIDGET',
};
